var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileTopOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.162,
    height: 25.958,
    viewBox: "0 0 23.162 25.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-489.75 -358.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M11.82,12.054a5.239,5.239,0,0,1-3.653-1.472,4.932,4.932,0,0,1,0-7.109,5.267,5.267,0,0,1,7.305,0,4.932,4.932,0,0,1,0,7.109A5.239,5.239,0,0,1,11.82,12.054Z",
    transform: "translate(489.513 358)",
    fill: "#dc3a1a",
    stroke: "#dc3a1a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.487,25.458V23.783A6.612,6.612,0,0,1,3.5,19.043a6.985,6.985,0,0,1,4.87-1.963h6.887a6.985,6.985,0,0,1,4.87,1.963,6.612,6.612,0,0,1,2.017,4.739v1.676",
    transform: "translate(489.513 358)",
    fill: "none",
    stroke: "#dc3a1a",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTopOrange);
export default __webpack_public_path__ + "static/media/profile_top_orange.003a053d3a8d0a6702c035ebced911f8.svg";
export { ForwardRef as ReactComponent };